import { render } from "./WomenShoes3.vue?vue&type=template&id=bc00bbb2"
import script from "./WomenShoes3.vue?vue&type=script&lang=js"
export * from "./WomenShoes3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__